<template>
    <img class="icon-img" :class="classname" :src="`${publicPath}static/images/ShopopeeTV.png`">
</template>

<script setup>

import {inject, computed} from "vue";

const props = defineProps(["shake"])

const i18n = inject("i18n")

const publicPath = process.env.BASE_URL

const classname = computed(() => {
    let name = ""

    if (props.shake === true){
        name = "shake-btn"
    }

    return name
})

</script>

<style scoped>

.icon-img {
    width: 50px;
    height: 50px;
}

.shake-btn {
    animation: shake-tv 1s linear infinite;
}

@keyframes shake-tv {
    0% {
        transform: rotate(-15deg);
    }
    4% {
        transform: rotate(15deg);
    }

    8%, 24% {
        transform: rotate(-18deg);
    }
    12%, 28% {
        transform: rotate(18deg);
    }
    16% {
        transform: rotate(-22deg);
    }
    20% {
        transform: rotate(22deg);
    }
    32% {
        transform: rotate(-12deg);
    }
    36% {
        transform: rotate(12deg);
    }
    40%, 100% {
        transform: rotate(0deg);
    }
}

</style>